// Create Code Basic
export const CREATE_CODE_BASIC_REQUEST = 'CREATE_CODE_BASIC_REQUEST';
export const CREATE_CODE_BASIC_DONE = 'CREATE_CODE_BASIC_DONE';
export const CREATE_CODE_BASIC_FAILED = 'CREATE_CODE_BASIC_FAILED';
export const CREATE_CODE_BASIC_RESET = 'CREATE_CODE_BASIC_RESET';